const ASSESSMENT_API_ENDPOINT =
  process.env.REACT_APP_NVFO_API_ENDPOINT || "http://localhost:4000/api/v1";

export type AssessmentLeadPayload = {
  name: string;
  phone?: string;
  email?: string;
  answers: Record<string, string>;
  matches: { country: string; program: string; score: number }[];
};

export const submitAssessmentLead = async (payload: AssessmentLeadPayload) => {
  const response = await fetch(`${ASSESSMENT_API_ENDPOINT}/leads`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    throw new Error(`assessment lead submission failed: ${response.status}`);
  }
};
